import { DropdownData, InputType } from 'src/app/common/components/reactive-form-builder/interfaces/input.interface';
import { Form, FormField, FormSection, FormType } from 'src/app/common/components/reactive-form-builder/interfaces/form.interface';
import {Component} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {DashboardService} from '../../../../../service/events/dashboard.service';
import {BaseForm} from '../../../../base-form';
import {build, list, stack} from '../../../../../common/classes/request-builder';
import {StorageManager} from '../../../../../common/storage-manager.class';
import { environment } from 'src/environments/environment';
import { PedidosApiService } from 'src/app/service/api/pedidos-api.service';
import { ProductosApiService } from 'src/app/service/api/productos-api';
import { FincasApiService } from 'src/app/service/api/fincas-api.service';

import type { OnInit } from '@angular/core';
import { PedidoModel } from 'src/app/models/visitas/pedido.model';
import { FincasModel } from 'src/app/models/form-common/fincas.module';
import type {
    ReactiveFormChangedField,
    ReactiveFormValue,
} from 'src/app/common/components/reactive-form-builder/interfaces/reactive-form-change.interface';

@Component({
    selector: 'app-visitas-pedidos-form',
    standalone: false,
    templateUrl: './visitas-pedidos-form.component.html',
    styleUrls: ['./visitas-pedidos-form.component.scss']
})
export class VisitasPedidosFormComponent extends BaseForm<PedidoModel> implements OnInit {

    public appName = environment.appName;
    public hasClients = environment.features.hasClients;
    public applicationType = environment.features.applicationType;
    public serverUrl = environment.serverUrl;

    public override model: PedidoModel = {};
    public reactiveForm!: { formType: FormType; model: Partial<PedidoModel>; formFields: Form<PedidoModel> };
    public id = 0;

    public fincas: DropdownData<FincasModel> = list();
    public nombreCliente = '';
    
    public productos1 = list();
    public productos2 = list();
    public productos3 = list();
    public productos4 = list();
    public productos5 = list();
    public productos6 = list();
    public productos7 = list();

    public signatureFile: File = new File([], '');

    public distributionOrder = [
        4, 3, 3, 3, 3, 3, 1
    ];

    public formFields: FormField<any>[] = [
    {
        name: 'id_finca',
        field: 'id_finca',
        vinculatedFields: undefined,
        label: 'Finca',
        input: { type: InputType.DROPDOWN, isEditable: true, data: this.fincas, dropdownConfiguration: { valuePrimaryKey: 'id' }, optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: Boolean(true), isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: Boolean(true),        values: this.fincas,

        order: 1
    },
    {
        name: 'albaran',
        field: 'albaran',
        vinculatedFields: undefined,
        label: 'Albarán',
        input: { type: InputType.TEXT, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 2
    },
    {
        name: 'fecha_pedido',
        field: 'fecha_pedido',
        vinculatedFields: undefined,
        label: 'Fecha Pedido',
        input: { type: InputType.CALENDAR, isEditable: true, calendarConfiguration: { calendarView: 'date', calendarDateFormat: 'dd/mm/yy' } },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 3
    },
    {
        name: 'fecha_entrega',
        field: 'fecha_entrega',
        vinculatedFields: undefined,
        label: 'Fecha Entrega',
        input: { type: InputType.CALENDAR, isEditable: true, calendarConfiguration: { calendarView: 'date', calendarDateFormat: 'dd/mm/yy' } },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 4
    },
    {
        name: 'producto1',
        field: 'producto1',
        vinculatedFields: undefined,
        label: 'Producto',
        input: { type: InputType.DROPDOWN_SEARCH, isEditable: true, data: this.productos1, dropdownConfiguration: { valuePrimaryKey: 'id' }, optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,        values: this.productos1,

        order: 5
    },
    {
        name: 'cantidad1',
        field: 'cantidad1',
        vinculatedFields: undefined,
        label: 'Cantidad',
        input: { type: InputType.NUMERIC, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 6
    },
    {
        name: 'lote1',
        field: 'lote1',
        vinculatedFields: undefined,
        label: 'Lote',
        input: { type: InputType.NUMERIC, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: Boolean(StorageManager.getUser().tipo !== 'comunero') },
        required: false,
        visible: StorageManager.getUser().tipo !== 'comunero',
        order: 7
    },
    {
        name: 'producto2',
        field: 'producto2',
        vinculatedFields: undefined,
        label: 'Producto 2',
        input: { type: InputType.DROPDOWN_SEARCH, isEditable: true, data: this.productos2, dropdownConfiguration: { valuePrimaryKey: 'id' }, optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,        values: this.productos2,

        order: 8
    },
    {
        name: 'cantidad2',
        field: 'cantidad2',
        vinculatedFields: undefined,
        label: 'Cantidad 2',
        input: { type: InputType.NUMERIC, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 9
    },
    {
        name: 'lote2',
        field: 'lote2',
        vinculatedFields: undefined,
        label: 'Lote 2',
        input: { type: InputType.NUMERIC, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: Boolean(StorageManager.getUser().tipo !== 'comunero') },
        required: false,
        visible: StorageManager.getUser().tipo !== 'comunero',
        order: 10
    },
    {
        name: 'producto3',
        field: 'producto3',
        vinculatedFields: undefined,
        label: 'Producto 3',
        input: { type: InputType.DROPDOWN_SEARCH, isEditable: true, data: this.productos3, dropdownConfiguration: { valuePrimaryKey: 'id' }, optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,        values: this.productos3,

        order: 11
    },
    {
        name: 'cantidad3',
        field: 'cantidad3',
        vinculatedFields: undefined,
        label: 'Cantidad 3',
        input: { type: InputType.NUMERIC, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 12
    },
    {
        name: 'lote3',
        field: 'lote3',
        vinculatedFields: undefined,
        label: 'Lote 3',
        input: { type: InputType.NUMERIC, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: Boolean(StorageManager.getUser().tipo !== 'comunero') },
        required: false,
        visible: StorageManager.getUser().tipo !== 'comunero',
        order: 13
    },
    {
        name: 'producto4',
        field: 'producto4',
        vinculatedFields: undefined,
        label: 'Producto 4',
        input: { type: InputType.DROPDOWN_SEARCH, isEditable: true, data: this.productos4, dropdownConfiguration: { valuePrimaryKey: 'id' }, optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,        values: this.productos4,

        order: 14
    },
    {
        name: 'cantidad4',
        field: 'cantidad4',
        vinculatedFields: undefined,
        label: 'Cantidad 4',
        input: { type: InputType.NUMERIC, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 15
    },
    {
        name: 'lote4',
        field: 'lote4',
        vinculatedFields: undefined,
        label: 'Lote 4',
        input: { type: InputType.NUMERIC, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: Boolean(StorageManager.getUser().tipo !== 'comunero') },
        required: false,
        visible: StorageManager.getUser().tipo !== 'comunero',
        order: 16
    },
    {
        name: 'producto5',
        field: 'producto5',
        vinculatedFields: undefined,
        label: 'Producto 5',
        input: { type: InputType.DROPDOWN_SEARCH, isEditable: true, data: this.productos5, dropdownConfiguration: { valuePrimaryKey: 'id' }, optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,        values: this.productos5,

        order: 17
    },
    {
        name: 'cantidad5',
        field: 'cantidad5',
        vinculatedFields: undefined,
        label: 'Cantidad 5',
        input: { type: InputType.NUMERIC, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 18
    },
    {
        name: 'lote5',
        field: 'lote5',
        vinculatedFields: undefined,
        label: 'Lote 5',
        input: { type: InputType.NUMERIC, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: Boolean(StorageManager.getUser().tipo !== 'comunero') },
        required: false,
        visible: StorageManager.getUser().tipo !== 'comunero',
        order: 19
    },
    {
        name: 'estado',
        field: 'estado',
        vinculatedFields: undefined,
        label: 'Estado',
        input: { type: InputType.DROPDOWN, isEditable: true, data: list(['...', null], 'Hecho', 'En Preparación', 'Entregado'), optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: Boolean(StorageManager.getUser().tipo !== 'comunero') },
        required: false,
        visible: StorageManager.getUser().tipo !== 'comunero',        values: list(['...', null], 'Hecho', 'En Preparación', 'Entregado'),

        order: 20
    },
];


    
    public adjunto = '';
    


    private createReactiveForm(): void {
        const formType = Number(this.getType()) as FormType;
        this.reactiveForm = {
            formType,
            model: this.model,
            formFields: {
                name: 'visitas-pedidos',
                header: this.getType() === FormType.EDITION ? this.headerTitleWhenEdit : this.headerTitleWhenNew,
                type: formType,
                sections: this.getReactiveSections(),
                table: null,
                uploadButton: { isEnabled: Boolean(false), label: '' },
                signed: Boolean(false),
            },
        };
    }

    private getReactiveSections(): FormSection<PedidoModel>[] {
        return [
            { name: 'Datos del pedido', fields: this.formFields, width: 12, isVisible: true, order: 1 },
        ];
    }

    public reactiveFormChanges(
        formModel: ReactiveFormValue<PedidoModel>,
        lastChangedFieldName: ReactiveFormChangedField<PedidoModel>,
    ): void {
        this.model = { ...this.model, ...formModel } as PedidoModel;
        (this.formChanges as (tag?: string) => void).call(this, String(lastChangedFieldName ?? ''));
        if (this.reactiveForm) {
            this.reactiveForm.model = this.model;
        }
    }

    constructor(
        public override dashboard: DashboardService,
        public override router: Router,
        public override route: ActivatedRoute,
        public pedidosApi: PedidosApiService,
        public fincasApi: FincasApiService,
        public productosApi: ProductosApiService         
    ) {
        super(
            route,
            router,
            dashboard,
            pedidosApi.pedidosPUT,
            pedidosApi.pedidosPOST,
            'visitas-pedidos',
            'Actualizar Pedido',
            'Realizar Pedido',
            'Duplicar Pedido'
        );
    }

    ngOnInit() {

        const userTipo = StorageManager.getUser().tipo;
        console.log(userTipo);
        // public distributionOrder = [
        //     4, 3, 3, 3, 3, 3, 1
        // ];
        if (userTipo === 'comunero'){
            this.distributionOrder = [4, 2, 2, 2, 2, 2, 1];
        }

        this.createReactiveForm();
        this.initFormData();
        this.softInit(this.getType());
    }

    getSignature( event: File ) {
        this.signatureFile = event;
    }
    
    updateFirma(event: string) {
        this.model.signature_img = event;
        this.formBuilderRef?.updateForm(this.model as unknown as Record<string, unknown>, false);
            this.dropdownsFinalized = true;
            this.dropdownLoadTrigger.next();
    }


    public formChanges() {

    }

    private initFormData(): Promise<boolean> {
        const builds = [
            build(this.fincasApi.fincasGET, this.fincas, 'nombre'),
            build(
                this.productosApi.productos.GET, 
                [this.productos1, this.productos2, this.productos3, this.productos4, this.productos5], 
                'nombre'
            )
        ];
        return stack(builds, () => {
            this.formBuilderRef?.updateForm(this.model as unknown as Record<string, unknown>, false);
            this.dropdownsFinalized = true;
            this.dropdownLoadTrigger.next();
        });
    }
}